module.exports = __webpack_public_path__ + "static/media/epay.396baa78.png";